import React from "react";
import classes from "./TabHeader.module.css";
import images from "../../assets/images";
const TabHeader = (props) => {
  const {
    isHidden = false,
    label,
    isActive,
    variant,
    showTabSeperator,
    badgeStyle,
    showCloseIcon,
    startAvatar,
    endAvatar,
    onClick,
    closeTab,
  } = props;
  const { close } = images;
  return (
    <>
      <div
        title={label?.toUpperCase()}
        className={`${classes["header"]} ${
          isHidden ? classes["hidden"] : null
        } ${variant && classes[variant]} ${isActive ? classes["active"] : ""}`}
        onClick={onClick}
      >
        {variant === "filled" && (
          <div style={{ ...badgeStyle }} className={classes["header-badge"]}>
            {label
              ?.split(" ")
              .map((l) => l.slice(0, 1))
              .join("")}
          </div>
        )}
        <div className={classes["header-label-container"]}>
          {startAvatar && (
            <div className={classes["startAvatar"]}>{startAvatar}</div>
          )}
          <div className={classes["header-label"]}>{label}</div>
          {endAvatar && <div className={classes["endAvatar"]}>{endAvatar}</div>}
        </div>
        {showCloseIcon && (
          <>
            <div
              className={classes["close"]}
              onClick={(e) => {
                e.stopPropagation();
                closeTab();
              }}
            >
              <img
                src={close}
                alt="close"
                style={{ width: "15px", height: "15px" }}
              />
            </div>
            {showTabSeperator && <div className={classes["tab-seperator"]} />}
          </>
        )}
        {isActive && variant !== "filled" && (
          <div className={classes["active-track"]} />
        )}
      </div>
    </>
  );
};

export default TabHeader;
